import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";

const DomainsIntervention = ({ cards }) => {
  const [flippedCards, setFlippedCards] = useState(new Set());
  const { t } = useTranslation();

  const toggleFlip = (cardId) => {
    setFlippedCards((prev) => {
      const newSet = new Set(prev);
      newSet.has(cardId) ? newSet.delete(cardId) : newSet.add(cardId);
      return newSet;
    });
  };

  return (
    <div className="domains-section">
      {/* Title Section */}
      <div className="domains-title">
        <h1>
          {t("domains.titleLine1")} <br />
          {t("domains.titleLine2")}
        </h1>
      </div>

      {/* Cards Grid */}
      <div className="cards-grid">
        {cards.map((card) => {
          const isFlipped = flippedCards.has(card.id);
          const isBlueCard = card.id === 0;

          return (
            <div key={card.id} className="card-wrapper">
              <div
                className={`card-inner ${isFlipped ? "flipped" : ""} ${
                  isBlueCard ? "blue-card" : ""
                }`}
                onClick={() => !isBlueCard && toggleFlip(card.id)}>
                {/* Front Side */}
                <div className="card-front">
                  {!isBlueCard && (
                    <>
                      <div className="card-icon">{card.icon}</div>
                      <h3 className="card-title">{card.title}</h3>
                      <p className="card-description">{card.description}</p>
                      <a
                        href="#"
                        className="card-link"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          toggleFlip(card.id);
                        }}>
                        {t("domains.seeMore")}
                      </a>
                    </>
                  )}
                </div>

                {/* Back Side */}
                {!isBlueCard && (
                  <div className="card-back">
                    <div className="card-points">
                      {card.backContent.map((item, idx) => (
                        <div key={idx} className="card-point">
                          <span>●</span>
                          <span>{item}</span>
                        </div>
                      ))}
                    </div>
                    <a
                      href="#"
                      className="card-back-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        toggleFlip(card.id);
                      }}>
                      {t("domains.back")}
                    </a>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DomainsIntervention;
